/* eslint-disable import/no-cycle */
import React from 'react';
import { GetStaticProps } from 'next';
import WithPage from '../HOC/Page/WithPage';
import MessageModel from '../models/Message';
import { TAuthMessages } from '../components/Auth/@types';
import MainLayout from '../layout/MainLayout';
import { getSiteData } from '../models/Contentful';
import type { Page } from '../models/Contentful/types';
import { DefaultPage, IStaticPageProps } from '../models/Contentful/types';
import { LayoutPage } from '../types/page';
import { SignUpFormSSO } from '../components/Auth/SignUpForm';

interface ISignupPage {
  messages: TAuthMessages;
}

const SignUp: LayoutPage<IStaticPageProps<ISignupPage>> = ({ page }) => {
  return (
    <div>
      <div>
        <main>
          <SignUpFormSSO messages={page.messages} />
        </main>
      </div>
    </div>
  );
};

export default WithPage(SignUp, true, true);

SignUp.getLayout = function getLayout(
  page: React.ReactElement,
  props: IStaticPageProps<DefaultPage>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps<IStaticPageProps<ISignupPage>> = async () => {
  const siteData = await getSiteData();
  const messages = await MessageModel.getMessageData([
    'Signup - Who you are?',
    'Signup - Setup Login',
    'Signup - Thank you',
  ]);

  return {
    props: { site: siteData.site, page: { messages } as Page & ISignupPage },
  };
};
